import classes from 'classnames';
import styles from './Placeholder.module.scss';

export type Props = {
  className?: string;
  dataTest?: string;
  value?: number | string;
  digits?: number;
  parseValue?: (value: number | undefined) => string | number;
  parseDate?: (value: string | undefined) => string;
  loading?: boolean;
};

export default function Placeholder({
  className,
  dataTest = 'placeholder',
  digits = 2,
  value,
  parseValue,
  parseDate,
  loading = false,
}: Props) {
  // value + date parsed if it's needed
  const dateParsed = typeof value === 'string' && parseDate?.(value);
  const valueParsed = typeof value === 'number' && parseValue?.(value);
  const valueDateParsed = valueParsed || dateParsed || value;

  return (
    <span
      className={classes(loading && styles.wrapper, className)}
      data-test={dataTest}
      data-testid={dataTest}
    >
      {loading ? '#'.repeat(digits) : valueDateParsed}
    </span>
  );
}
